<template>
  <ul class="office_space_list">
    <item :item="item" v-for="(item,idx) in list" :key="item.id" />
  </ul>
</template>

<script>
import item from "./item.vue";
export default {
  props: {
    list: {
      type: Array
    }
  },

  components: {
    item
  }
};
</script>

<style lang="scss" scoped>
.office_space_list {
  display: flex;
  flex-wrap: wrap;
  .office_space_item:nth-child(3n) {
    margin-right: 0;
  }
}
</style>